import React, { useEffect, useState } from 'react';
import { useVersionInfo } from '../hooks/useVersionInfo';
import { getAppEnvLabel, isDevelopmentEnv } from '../utils/appEnv';
import { useI18n } from '../i18n';
import { getBackendVersionApi } from '../lib/versionApi';
import FooterLinks from './FooterLinks';

const formattedBuildDate = new Date(__BUILD_TIMESTAMP__).toLocaleString('nl-NL', {
  dateStyle: 'short',
  timeStyle: 'short'
});

const SubtleFooter: React.FC = () => {
  const versionInfo = useVersionInfo();
  const modeLabel = getAppEnvLabel();
  const [aiVersion, setAiVersion] = useState('');
  const { t } = useI18n();
  const modeClassName = isDevelopmentEnv()
    ? 'bg-blue-50 text-blue-700'
    : 'bg-gray-100 text-gray-700';

  useEffect(() => {
    const fetchAiVersion = async () => {
      try {
        const data = await getBackendVersionApi();
        if (!data) return;
        setAiVersion(typeof data.version === 'string' ? data.version : '');
      } catch {
        setAiVersion('');
      }
    };

    void fetchAiVersion();
  }, []);

  const getBuildDisplay = () => (versionInfo ? `#${versionInfo.buildNumber}` : '');

  return (
    <footer className="mx-auto max-w-2xl px-4 pb-6 text-center text-[11px] text-gray-500 space-y-3 font-sans">
      <div className="space-y-1">
        <div className="flex items-center justify-center gap-2 flex-wrap">
          <span>Platform v{versionInfo?.version}{getBuildDisplay()}</span>
          <span className="text-gray-300">|</span>
          <span>AI v{aiVersion || '-'}</span>
          <span className="text-gray-300">|</span>
          <span className={`px-2 py-0.5 rounded-full text-[10px] ${modeClassName}`}>{modeLabel}</span>
        </div>
        <div className="text-gray-500">
          <span>{t('footer_build_timestamp', { date: formattedBuildDate })}</span>
        </div>
      </div>
      <div className="text-gray-500">
        <span>© 2025 - {new Date().getFullYear()} | {t('footer_built_with_ai')}
          <a className="text-primary-600 hover:text-primary-700" href="https://waedo.nl/">Waedo</a> in Oirschot
        </span>
      </div>
      <FooterLinks className="justify-center" />
      <div className="border-t border-gray-200 pt-3 text-[11px] leading-relaxed text-gray-500">
        <span className="font-semibold">{t('footer_disclaimer_title')}</span>{' '}
        <span>{t('footer_disclaimer_body')}</span>
      </div>
    </footer>
  );
};

export default SubtleFooter;
